module.exports = __webpack_public_path__ + "static/media/logotype_mono.1536435c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/main/logotype_mono.svg
// module id = 972
// module chunks = 124